import * as React from 'react';
import Cyrcmm from './cy_rcmm/Module';
import Cyrcts from './cy_rcts/Module';
import './css.scss';

const Module = (props: any) => {
    if (props.device === 'PC') {
        return <Cyrcts {...props} />;
    } else {
        return <Cyrcmm {...props} />;
    }
};

export default Module;
